const React = require("react");

function CheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = CheckCircleIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/CheckCircleIcon.js
 ** module id = 469
 ** module chunks = 0
 **/